import serviceRequest from "utils/request";

const baseUrl = "/api/booksetup";

export const getAccessAllUserBookings = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-alluser-bookings`,
		method: "get",
		params,
	});
};

export const getAccessAllUserBookingsHistory = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-alluser-bookings-history`,
		method: "get",
		params,
	});
};

export const getAccessReleaseTime = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-release-time`,
		method: "post",
		data,
	});
};

export const getAcccessUserProjects = () => {
	return serviceRequest({
		url: `${baseUrl}/get-user-projects`,
		method: "get",
	});
};

export const getAccessBookedProjectsByStatus = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-booked-projects-by-status`,
		method: "get",
		params,
	});
};

export const getAccessCapacityFull = (params) => {
	return serviceRequest({
		url: `${baseUrl}/capacity-full`,
		method: "get",
		params,
	});
};

export const getAccessAddProjects = (params) => {
	//console.log("params", params);
	return serviceRequest({
		url: `${baseUrl}/get-add-projects`,
		method: "get",
		params,
	});
};

export const updateLabAvailability = (params) => {
	return serviceRequest.post(`${baseUrl}/update-lab-availability`, params);
};

export const getBookedActiveProjects = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-booked-active-projects`,
		method: "get",
		params,
	});
};

export const allBookingSubmit = (params) => {
	return serviceRequest({
		method: "post",
		url: `${baseUrl}/all-booking-submit`,
		data: params,
		noErrorMessage: true,
	});
};

export const exportAllUserBookings = (data) => {
	return serviceRequest({
		url: `${baseUrl}/export-alluser-bookings`,
		method: "post",
		responseType: "blob",
		data,
	});
};

export const generateEmail = (params) => {
	return serviceRequest.post(`${baseUrl}/generate-email`, params);
};

export const emailNotification = (params) => {
	return serviceRequest.post(`${baseUrl}/email-notification`, params);
};

export const capacityAboveApproved = (params) => {
	return serviceRequest.post(`${baseUrl}/capacity-above-approved`, params);
};

export const getBookingUser = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-booking-user`,
		method: "get",
		params,
	});
};

export const getAccessBookingUser = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-booking-user/v2`,
		method: "get",
		params,
	});
};

export const bookingBatchApprove = (data) => {
	return serviceRequest({
		url: `${baseUrl}/batch-approve`,
		method: "post",
		data,
	});
};

export const bookingBatchCancel = (data) => {
	return serviceRequest({
		url: `${baseUrl}/batch-cancel`,
		method: "post",
		data,
	});
};

export const bookingBatchReject = (data) => {
	return serviceRequest({
		url: `${baseUrl}/batch-reject`,
		method: "post",
		data,
	});
};

export const getProjectMembers = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-project-members`,
		method: "get",
		params,
	});
};
